export enum ValuationQualityWP {
    Green = 'Green',
    Yellow = 'Yellow',
    Red = 'Red'
}
